import { IMapCategories } from './IMapCategories';

const categories : IMapCategories = {
  AM: 'Ambient',
  CH: 'Chilled',
  CHNC: 'Chilled NC',
  CL: 'Chilled long life',
  CS: 'Chilled short life',
  FR: 'Frozen',
  TB: 'Tobacco',
  EX: 'Expenses',
  CO: 'Combined',
};

export const mapCategory = (category: string) : string => {
  return categories[category] || category;
};

export const mapCategoryStyle = (category: string): string => {
  return mapCategory(category).toLowerCase().replace(' ', '-');
};
